import { useTranslation } from 'react-i18next'

import { useGretaAIChatContext } from '../../GretaAIChat.hooks'

import { getGretaAIChatPanelProjectActionContent } from './GretaAIChatPanelProjectAction.utils'

function GretaAIChatPanelProjectAction() {
  const { t } = useTranslation()

  const { actions, panel } = useGretaAIChatContext()

  const { chatStatusById, projectAction } = panel

  const {
    onCloseProjectAction,
    onConfirmDeleteProject,
    onConfirmRenameProject,
  } = actions

  return getGretaAIChatPanelProjectActionContent({
    chatStatusById,
    projectAction,
    t,
    onCancel: onCloseProjectAction,
    onConfirmDelete: onConfirmDeleteProject,
    onConfirmRename: onConfirmRenameProject,
  })
}

export default GretaAIChatPanelProjectAction
